import {
  CollectionOptions,
  ContentInstructions,
  CoreContents,
  ExportOptions,
  FromSettingsInstruction,
} from '../../../types';
import { DataOptionsFactory } from '../data';
import { ContentFactory } from './base';

export type SegmentationOptions = {
  data?: DataOptionsFactory;
  displayAs?: string | FromSettingsInstruction;
  yColumn: string | FromSettingsInstruction;
  xColumn: string | FromSettingsInstruction;
  segmentColumn: string | FromSettingsInstruction;
  exportOptions?: ExportOptions;
  collectionOptions?: CollectionOptions;
};

export class SegmentationFactory extends ContentFactory {
  constructor(options: SegmentationOptions) {
    const { xColumn, yColumn, data, segmentColumn, displayAs, exportOptions, collectionOptions } = options;

    const instructions: ContentInstructions = {
      xColumn:
        typeof xColumn === 'string'
          ? {
              type: 'StringInstruction',
              instruction: xColumn,
            }
          : xColumn,
      yColumn:
        typeof yColumn === 'string'
          ? {
              type: 'StringInstruction',
              instruction: yColumn,
            }
          : yColumn,
      segmentColumn:
        typeof segmentColumn === 'string'
          ? {
              type: 'StringInstruction',
              instruction: segmentColumn,
            }
          : segmentColumn,
      ...(exportOptions && {
        export: {
          type: 'ObjectInstruction',
          instruction: exportOptions,
        },
      }),
      ...(collectionOptions && {
        collection: {
          type: 'ObjectInstruction',
          instruction: collectionOptions,
        },
      }),
    };

    if (displayAs) {
      instructions.displayAs =
        typeof displayAs === 'string'
          ? {
              type: 'StringInstruction',
              instruction: displayAs,
            }
          : displayAs;
    }

    super(CoreContents.segmentation, {
      data: data || DataOptionsFactory.asReceiver(),
      instructions,
    });
  }
}
